import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Box } from 'seagull';
import { NotificationEmailPreview } from '~/components/NotificationPreview/NotificationEmailPreview/NotificationEmailPreview';
import { NotificationSmsPreview } from '~/components/NotificationPreview/NotificationSmsPreview/NotificationSmsPreview';
import styles from './NotificationPreviewBox.module.scss';
import { ctaTextFor, notificationNameOf } from './NotificationPreviewBox.utils';
export const NotificationPreviewBox = (param)=>{
    let { entry, delivery, vendorLogoUrl, emailTestId, smsTestId, inRow = false } = param;
    const vendorBusinessName = entry.data().vendorName;
    if (delivery.channel.type === 'email') {
        const previewClass = cn(styles.preview, {
            [styles.previewInRow]: inRow,
            [styles.previewInRowEmail]: inRow
        });
        return /*#__PURE__*/ _jsx(Box, {
            testId: emailTestId,
            className: previewClass,
            children: /*#__PURE__*/ _jsx(NotificationEmailPreview, {
                notificationName: notificationNameOf(entry.state()),
                subject: delivery.channel.email.subject,
                message: delivery.channel.email.body,
                templateVariables: {},
                ctaButtonText: ctaTextFor(entry.state()),
                branding: {
                    type: 'business',
                    name: vendorBusinessName,
                    logoUrl: vendorLogoUrl
                },
                vendorBusinessName: vendorBusinessName
            })
        });
    }
    const previewClass = cn(styles.preview, {
        [styles.previewInRow]: inRow,
        [styles.previewInRowSms]: inRow
    });
    return /*#__PURE__*/ _jsx(Box, {
        testId: smsTestId,
        className: previewClass,
        children: /*#__PURE__*/ _jsx(NotificationSmsPreview, {
            message: delivery.channel.sms.body,
            templateVariables: {},
            vendorBusinessName: vendorBusinessName
        })
    });
};
